import { Grid } from "@mui/material";
import { useContext } from "react";

import Context from "../../context";
import DTextInput from "../DTextInput";
import DLoginSelector from "../LoginSelector/DLoginSelector";

// ----------------------------------------------------------------------

type Props = {
	onChangeSelect: (value: string) => void;
	selectedValue: string;
};

export const InputSelector = ({ onChangeSelect, selectedValue }: Props) => {
	const { params } = useContext(Context);
	const selector = params.find((field) => field.type === "select");
	const entitySelected = params.find(
		(field) => field.visibility?.values?.find((i) => i === selectedValue)
	);

	const isUsername = selectedValue === "username";

	return (
		<Grid container spacing={2}>
			<Grid item xs={isUsername ? 12 : 5}>
				<DLoginSelector
					label={selector?.label ?? ""}
					onChangeSelect={onChangeSelect}
					selectedValue={selectedValue}
					values={selector?.options ?? []}
				/>
			</Grid>
			{!isUsername && (
				<Grid item xs={7}>
					<DTextInput label={entitySelected?.label} name={entitySelected?.name ?? ""} />
				</Grid>
			)}
		</Grid>
	);
};

export default InputSelector;
